import { AIChatThumbDownIcon, AIChatThumbUpIcon } from '@/assets/icons/icons';
import type { HelpVoteButtonsProps } from '../../types';
import styles from '../../AppHelpCenter.module.scss';

const HelpVoteButtons = ({ vote, onVote, className }: HelpVoteButtonsProps) => (
  <div className={className}>
    <button
      type='button'
      aria-label='Helpful'
      aria-pressed={vote === 'up'}
      className={`${styles.articleFeedbackButton} ${
        vote === 'up' ? styles.articleFeedbackButtonActive : ''
      }`}
      onClick={() => onVote('up')}
    >
      <AIChatThumbUpIcon width={16} height={16} color='currentColor' />
    </button>
    <button
      type='button'
      aria-label='Not helpful'
      aria-pressed={vote === 'down'}
      className={`${styles.articleFeedbackButton} ${
        vote === 'down' ? styles.articleFeedbackButtonActive : ''
      }`}
      onClick={() => onVote('down')}
    >
      <AIChatThumbDownIcon width={16} height={16} color='currentColor' />
    </button>
  </div>
);

export default HelpVoteButtons;
